import { Amplify } from 'aws-amplify'
import { decodeJWT, TokenProvider } from 'aws-amplify/auth'
import { awsCredentialsProvider } from 'app/app'

export function initialiseAmplifyWithTokenProvider(
    idToken: string,
    accessToken: string,
    userId: string
) {
    const TuhiTokenProvider: TokenProvider = {
        async getTokens({ forceRefresh } = {}) {
            if (forceRefresh) {
                // try to obtain new tokens if possible
            }

            const accessTokenString = accessToken
            const idTokenString = idToken

            return {
                accessToken: decodeJWT(accessTokenString),
                idToken: decodeJWT(idTokenString),
            }
        },
    }

    // This runs during login to install the MSAL-backed token provider and the
    // per-user S3 prefix resolver (both only known after auth). We pass the
    // ALREADY-CONFIGURED resources back via Amplify.getConfig() and only change
    // library options, rather than re-specifying resources from
    // amplifyconfiguration.json. That preserves everything app.tsx set up —
    // including the CDK-owned `tuhiDev` REST endpoint injected there — so
    // post-login REST calls (HD upgrade, QR auth, subscription, form submission)
    // don't break with "API name is invalid".
    Amplify.configure(Amplify.getConfig(), {
        Auth: {
            tokenProvider: TuhiTokenProvider,
            credentialsProvider: awsCredentialsProvider,
        },
        Storage: {
            S3: {
                prefixResolver: async ({ accessLevel, targetIdentityId }) => {
                    if (accessLevel === 'protected') {
                        return `protected/${userId}/`
                    }
                    // Every storage call passes `path`, which skips this
                    // resolver. Other levels use Amplify's own default prefixes.
                    if (accessLevel === 'private') {
                        return `private/${targetIdentityId}/`
                    }
                    return 'public/'
                },
            },
        },
    })

    // DataStore is already configured in app.tsx - no need to reconfigure here
}
